import { useRouter } from 'vue-router';

import uuid from './uuid';

import { getEventIdFromUrl } from '@/utils/url';

export function makeUnique<T>(array: T[]): T[] {
  return array.reduce((a, b) => (a.includes(b) ? a : a.concat(b)), [] as T[]);
}

export async function retry<T>(fn: () => Promise<T>, retriesLeft: number = 5, interval: number = 1000): Promise<T> {
  try {
    return await fn();
  } catch (error) {
    if (retriesLeft) {
      await new Promise(r => setTimeout(r, interval));
      return retry(fn, retriesLeft - 1, interval);
    }
    throw new Error(`Max retries reached for function ${fn.name}`);
  }
}

export function generatePersistentUUID() {
  const router = useRouter();
  const urlBasedEventId = getEventIdFromUrl();
  const storageKey = `${router?.currentRoute.value.params?.eventID || urlBasedEventId || ''}_persistentUUID`;
  let persistentUUID = localStorage.getItem(storageKey);

  if (!persistentUUID) {
    persistentUUID = `user_${uuid()}_${Date.now()}`;
    localStorage.setItem(storageKey, persistentUUID);
  }

  return persistentUUID;
}

export async function hashOTP(otp: string): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(otp));
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
